import index from './index.vue';
import { AddFormType, SelectType } from './all.type';

export default index;
export {
    AddFormType,
    SelectType
};